import React, { useEffect, useState } from "react";
import { useMembership } from "@/components/membership/MembershipContext";
import { membershipApi } from "@/api/membershipClient";

const PRICES = { free: 0, professional: 49, executive: 199, enterprise: 999 };
const TIER_COLORS = { free: "#60B8E8", professional: "#7AC860", executive: "#F5C842", enterprise: "#E8A020" };

export default function UpgradeModal({ featureKey, requiredTier, onClose }) {
  const { tier, setDemoTier } = useMembership();
  const [catalog, setCatalog] = useState(null);
  const [savingTier, setSavingTier] = useState(null);

  useEffect(() => {
    membershipApi.tiers().then((r) => setCatalog(r.data)).catch(() => {});
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const tiers = catalog?.tiers || ["free", "professional", "executive", "enterprise"];
  const labels = catalog?.labels || {};
  const prices = catalog?.prices_usd || PRICES;

  const choose = (t) => {
    setSavingTier(t);
    setDemoTier(t);
    setTimeout(() => { setSavingTier(null); onClose(); }, 400);
  };

  return (
    <div className="upgrade-modal" role="dialog" aria-modal="true" data-testid="upgrade-modal">
      <button type="button" className="upgrade-modal__bg" aria-label="Close" onClick={onClose} />
      <div className="upgrade-modal__panel">
        <header className="upgrade-modal__head">
          <div className="upgrade-modal__crest" aria-hidden="true">❖</div>
          <div>
            <h3 className="upgrade-modal__title">Unlock {featureKey?.replace(/_/g, " ")}</h3>
            <p className="upgrade-modal__sub">
              Requires <strong style={{ color: TIER_COLORS[requiredTier] }}>{requiredTier?.toUpperCase()}</strong> tier or higher. Current: <strong>{(tier || "free").toUpperCase()}</strong>.
            </p>
          </div>
          <button type="button" className="upgrade-modal__x" onClick={onClose} aria-label="Close" data-testid="upgrade-close">×</button>
        </header>

        <div className="upgrade-modal__grid">
          {tiers.map((t) => {
            const isAtOrAbove = tiers.indexOf(t) >= tiers.indexOf(requiredTier || "free");
            const isCurrent = t === tier;
            return (
              <article key={t} className={`upgrade-tier ${isAtOrAbove ? "is-unlock" : ""} ${isCurrent ? "is-current" : ""}`} style={{ borderColor: TIER_COLORS[t] }} data-testid={`upgrade-tier-${t}`}>
                <header className="upgrade-tier__head" style={{ color: TIER_COLORS[t] }}>
                  {labels[t] || t.toUpperCase()}
                </header>
                <div className="upgrade-tier__price">{prices[t] === 0 ? "FREE" : `$${prices[t]} / mo`}</div>
                <button
                  type="button"
                  className="upgrade-tier__cta"
                  disabled={savingTier !== null}
                  onClick={() => choose(t)}
                  data-testid={`upgrade-tier-cta-${t}`}
                >
                  {isCurrent ? "Current" : isAtOrAbove ? `Select ${labels[t] || t}` : "Below required"}
                </button>
              </article>
            );
          })}
        </div>

        <footer className="upgrade-modal__foot">
          Demo mode — no payment processor wired. Tier choice is preserved for this browser only.
        </footer>
      </div>
    </div>
  );
}
